<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" title="2. Artichoke ‘Violetto di Romagna’">
<div class="titlepage">
<div>
<div>
<h1 class="title"><a id="d0e78" xmlns:saxon="http://icl.com/saxon">2.
                            Artichoke ‘Violetto di Romagna’</a></h1><a id="d0e78" xmlns:saxon="http://icl.com/saxon">
</a></div><a id="d0e78" xmlns:saxon="http://icl.com/saxon">
<div>
<h3 class="subtitle">
<i>Cynara scolymus</i>
</h3>
</div>
</a></div><a id="d0e78" xmlns:saxon="http://icl.com/saxon">
</a></div><a id="d0e78" xmlns:saxon="http://icl.com/saxon">
<div class="epigraph">
<p>In Scotland in the nineteenth century, artichokes were so highly valued that it
                    was thought only prosperous men should have the right to grow them and that it
                    would be impertinent for a lesser man to even attempt such a folly. </p>
</div>
<p>The artichoke is actually the edible ﬂower bud of a large, thistlelike plant of the
                sunﬂower family that is native to the Mediterranean and Near East, its common name
                coming to us from the Arabic <span class="emphasis"><em>al kharshuf.</em></span> The
                Moroccan invaders brought the artichoke to Spain in the ninth or tenth century,
                whence it became <span class="emphasis"><em>alcahofa,</em></span> the Italians
                subsequently turning it to <span class="emphasis"><em>carciofa.</em></span> The
                Romans were fond of having artichokes imported from Carthage and Cordova for their
                banquets, and thought the plants’ spines looked like the teeth of Cynara, the dog of
                mythological tales, thus this cultivar’s Latin sobriquet <span class="emphasis"><em>Cynara scolymus.</em></span></p>
<p>In the ﬁrst century A.D., the Roman naturalist Pliny noted, though not with great
                pleasure, that in his time the artichoke was held in higher esteem than any other
                potherb in Rome, further commenting that even donkeys were smart enough to refuse to
                eat them. Introduced into England in 1548, an amusing piece of Elizabethan folklore
                held that the artichoke was created when an ill-tempered beauty angered the gods and
                was transformed by them into a prickly thistle, a form more suitable to her
                personality. At the turn of the nineteenth century, the German poet Goethe was, like
                Pliny, apparently appalled by the continental taste for artichokes, exclaiming
                incredulously in his <span class="emphasis"><em>Travels Through Italy:</em></span>
                “The peasants eat thistles!”</p>
<p>Like many antique vegetables, artichokes were prescribed by ancient physicians for
                all kinds of physical ailments, from jaundice and coughs to the faltering libidos of
                men, the French herbalists Estienne and Liebault coyly suggesting in the sixteenth
                century that a diet rich in artichoke extracts could cure “weakness of the
                generative parts.” The juice, when pressed from the plant before it blossomed, was
                also used as a wildly popular hair restorative. Currently, the world’s main growers
                of artichokes are Italy, Spain, Argentina, Morocco, and the United States, where the
                Swiss who ﬁrst established the vineyards in California’s Salinas Valley also founded
                the booming Pajaro Valley artichoke industry, now a $50 million a year crop.</p>
<p>The Italians have made selections of both purple and green artichokes since the
                ﬁfteenth century, the purple varieties, historically, thought to be more tender than
                green types. The regal and prettily named ‘Violetto di Romagna’ is an ancient
                Italian heirloom: a large, round-headed, imperial beauty possessed of buds
                dramatically blushed with a deep royal purple, surrounded by the requisite,
                exquisite froth of deeply serrated, silvery leaves. If I had to pick one major piece
                of architecture to anchor a vegetable bed or add visual punch to a mixed border,
                ‘Violetto di Romagna’ would be it.</p>
<p>Artichokes thrive in the cool, wet, temperate, coastal climes of central California,
                where they grow to a truly stately 5 feet tall. When grown as perennials, they have
                a life span of about ﬁve years and are propagated in winter or spring from root
                divisions. Divisions should be spaced 4 to 6 feet apart, with the growth buds or
                shoots just above the soil surface. These recipe tips from John Evelyn’s <span class="emphasis"><em>Acetaria</em></span> of 1699, when applied to the infant
                buds, are as delicious now as they were back then: “The heads being split in
                quarters ﬁrst eaten raw with oyl, a little vinegar, salt and pepper...they are
                likewise, while tender and small, fried in fresh butter crisp with persley.”</p>
<div class="mediaobject" title="This is an image of Artichoke ‘Violetto di Romagna’.">
<img alt="2. Artichoke ‘Violetto di Romagna’" src="images/0.jpg"/>
<div class="caption">
<p>Artichoke ‘Violetto di Romagna’</p>
</div>
</div>
</a></div><a id="d0e78" xmlns:saxon="http://icl.com/saxon">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch03.vue?ffc7d8ae